import {createSvgIcon} from "@mui/material";

const ChevronLeftIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M11.6665 15L6.6665 10L11.6665 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
          strokeLinejoin="round"/>
  </svg>,
  'ChevronLeft'
)

export default ChevronLeftIcon
